import axios from "axios";

export const fetchSchema = async (url, defaultSchema) => {
  try {
    const response = await axios.get(url);
    return response.data.properties.metadata;
  } catch (error) {
    console.error(`Failed to fetch schema from ${url}, using default:`, error);
    return defaultSchema;
  }
};
